import { defaultSelectBestPackage, PSSizeMode } from "~/utils/cartHelper";
import { INVALID_PACKAGE_CODE } from "~/utils/constants";
import { type PackCodeProvider } from "~/features/addToCart/hooks/useAddToCartForm";
import { isSelectablePack } from "~/domains/product/utils/isSelectablePack";

export const makeSalesAwarePackCodeProvider =
  (restrictionQuery: string | null, includeSoldOut = true): PackCodeProvider =>
  (productDescriptor, quantity) => {
    let allPackages = productDescriptor.availability!.packagingInformation.filter((p) =>
      isSelectablePack(productDescriptor, p),
    );
    if (restrictionQuery) {
      const restricted = allPackages.filter((p) => p.packCode === restrictionQuery);
      if (restricted.length > 0) {
        allPackages = restricted;
      }
    }
    return (
      defaultSelectBestPackage(
        quantity,
        allPackages.map((p) => p.packCode),
        productDescriptor,
        PSSizeMode.SMALLEST_FIRST,
        includeSoldOut,
      )?.packCode ?? INVALID_PACKAGE_CODE
    );
  };
